import { SuSyApi } from './susyApi';

export const sendEmailToAdmins = async (subject: string, body: string) => {
    await SuSyApi.post(`/emailNotification/notifyAdmins`, {
        subject,
        body,
    });
};
